<template>
  <div
    class="row order flex justify-content-center"
    v-on:click="showDetail">
    <div class="col-md-4 col-7 text-left flex align-items-center">
      <div class="text-content align-items-center">
        Orden: <strong>{{ order.id }}</strong> <br />
        <img src="../assets/Calendario.png" width="15" />
        <span class="text-nowrap faded"
          >{{ order.date }}<br />
          <img src="../assets/Cupon.png" />
          <span class="text-nowrap faded cupon"
            >{{ order.coupons }} cupones</span
          >
        </span>
        <br />
      </div>
    </div>
    <div class="col-md-4 col-5 flex align-items-center">
      <div  class="actions">
        <div class="d-none d-lg-inline-block ml-3"></div>
        <div
          v-if="mutable == true"
          class="action align-items-center"
          v-on:click="onAcceptDialog($event, order)"
        >
          <span class="sign">&#10003;</span>
          <span>| {{ acceptText }}</span>
        </div>
        <br/>
        <div
          v-if="mutable == true"
          class="action align-items-center remove"
          v-on:click="onRejectDialog($event, order)"
        >
          <span class="sign">&#215;</span>
          <span>| {{ rejectText }}</span>
        </div>
      </div>
      <div
        v-if="mutable == false"
        class="text-content align-items-center"
      >
        <span class="status-container">
          <img
            v-if="order.status == 'done'"
            src="../assets/icon-done.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'return'"
            src="../assets/icon-return.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'return_client'"
            src="../assets/icon-return-client.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'draft'"
            src="../assets/icon-draft.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'cancel'"
            src="../assets/icon-cancelled.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'order'"
            src="../assets/icon-inprogress.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'receive'"
            src="../assets/icon-inprogress.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'rejected_reception'"
            src="../assets/icon-cancelled.svg"
            class="status-icon"
          />
          <img
            v-if="order.status == 'claim'"
            src="../assets/icon-cancelled.svg"
            class="status-icon"
          />
          <br />
          <span class="text-nowrap faded state">{{ translateStatus() }}</span>
        </span>
      </div>
    </div>
    <v-layout row justify-center>
      <v-dialog v-model="dialogCorrections" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Correciones</v-card-title>
              <v-tabs fixed-tabs>
                <v-tab v-on:click="changeList('new')" key="new">
                  Nuevo
                </v-tab>
                <v-tab v-on:click="changeList('old')" key="old">
                  Viejo
                </v-tab>
              </v-tabs>
            <v-card-text>
            <li v-for="item in listCorrection" v-bind:key="item.name">
              {{ item.name }} ({{ item.qty }})<br /><p>
              {{ item.description }}</p>
            </li>
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="dialogCorrections = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: "OrderRow",
  props: [
    "order", "mutable", "acceptText", "rejectText", "onAcceptDialog",
    "onRejectDialog"
  ],
  data: function() {
    return {
      listCorrection: [],
      dialogCorrections: false,
      collapsed: false
    };
  },
  methods: {
    changeList: function(key){
      this.listCorrection = [];
      this.order.corrections.forEach((el) => this.listCorrection.push(el[key]));
    },
    showDetail: function(event) {
      if (this.order.status == 'rejected_reception'){
        this.dialogCorrections = true;
        this.changeList('new');
      }
      else {
        var self = this;
        event.stopPropagation()
        this.$dialog.alert(
          {
            title: "Detalle de orden",
            body: self.orderDetail()
          },
          {
            okText: "Continuar",
            html: true
          }
        );
      }
    },
    orderDetail: function() {
      var content = "<ul>";
      if (this.order.status == 'rejected_reception'){
        for (var i = 0; i < this.order.corrections.length; i++) {
          content +=
            "<li><p>" +
            this.order.corrections[i].new.name +
            "(" +
            this.order.corrections[i].new.qty +
            ")" +
            "<br />" +
            "<p>" +
            this.order.corrections[i].new.description +
            "</p>";
          ("</p></li>");
          content +=
            "<li><p>" +
            this.order.corrections[i].old.name +
            "(" +
            this.order.corrections[i].old.qty +
            ")" +
            "<br />" +
            "<p>" +
            this.order.corrections[i].old.description +
            "</p>";
          ("</p></li>");
        }
        content += "</ul>";
      }
      else{
        for (var i = 0; i < this.order.detail.length; i++) {
          content +=
            "<li><p>" +
            this.order.detail[i].name +
            "(" +
            this.order.detail[i].qty +
            ")" +
            "<br />" +
            "<p>" +
            this.order.detail[i].description +
            "</p>";
          ("</p></li>");
        }
        content += "</ul>";
      }
      
      return content;
    },
    translateStatus: function() {
      let self = this;
      return self.$store.state.translations.state[self.order.status];
    }
  }
};
</script>

<style scoped>
.only-screen {
  margin-top: 10px;
}
.action {
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(94, 158, 203);
  margin-bottom: 3px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 7px;
  margin-right: 5px;
  color: #ffffff;
  min-width: 100px;
}
.sign {
  width: 15px;
  text-align: center;
  color: #ffffff;
  margin-left: 5px;
}
.remove {
  background-color: rgb(221, 47, 0);
}
.action span {
  margin-left: 3px;
}
.action img {
  max-height: 20px;
}
button {
  margin: 4px;
}
svg {
  margin-left: 5px;
  cursor: pointer;
}
.detail {
  margin-top: 4px;
}
.order {
  background-color: rgba(54, 127, 178, 0.1);
  display: flex;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 760px;
}
.faded {
  color: rgb(152, 145, 150);
}
.cupon {
  margin-right: 10px;
}
.flex {
  display: flex;
}
.text-content img {
  margin-top: -5px;
  margin-right: 5px;
}
</style>
